<template>
  <div class="py-4 container-fluid mx-0 px-0">
    <div class=" row">
      <div class="col-12"> 
        <influencers-table />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import InfluencersTable from "./components/InfluencersTable.vue";

export default {
  name: "tables",
  components: {
    InfluencersTable,
  },
  data() {
    return {
      influ_count : 0,

    };
  },
  mounted () {
    

    var user = window.localStorage.getItem('$logged_user');
    if (user != 'admin')
      this.$router.push('/')
  }
};
</script>
